<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12.71,9.29C12.71,9.29,8.71,5.29,8.71,5.29C8.530000000000001,5.11,8.280000000000001,5,8,5C7.72,5,7.47,5.11,7.29,5.29C7.29,5.29,3.29,9.29,3.29,9.29C3.11,9.469999999999999,3,9.719999999999999,3,10C3,10.55,3.45,11,4,11C4.28,11,4.53,10.89,4.71,10.71C4.71,10.71,8,7.41,8,7.41C8,7.41,11.29,10.7,11.29,10.7C11.47,10.89,11.72,11,12,11C12.55,11,13,10.55,13,10C13,9.719999999999999,12.89,9.469999999999999,12.71,9.29C12.71,9.29,12.71,9.29,12.71,9.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ChevronUp',
} as DefineComponent
</script>
